import { CollectionLineConfig } from './constants.d';

export const DELIVERY_TIME = 'delivery_time';
export const GLOVES = 'GlovesRecommendedUses';
export const COLLECTION_LINE = 'Kollektionslinie';
export const SIZE = 'size';
export const COLOUR = 'hue';
export const GENDER = 'gender';

// The key is the Collection Line ID, as received from BSITE/PCS via Backend
export const COLLECTION_LINE_CONFIG: CollectionLineConfig = {
    '1': {
        collectionName: 'image',
        svgClassName: 'es_image',
        tooltipImageClassname: 'collection-image'
    },
    '2': {
        collectionName: 'active',
        svgClassName: 'es_active',
        tooltipImageClassname: 'collection-active'
    },
    '3': {
        collectionName: 'prestige',
        svgClassName: 'es_prestige',
        tooltipImageClassname: 'collection-prestige'
    },
    '4': {
        collectionName: 'roughtough',
        svgClassName: 'es_roughtough',
        tooltipImageClassname: 'collection-roughtough'
    },
    '5': {
        collectionName: 'motion',
        svgClassName: 'es_motion',
        tooltipImageClassname: 'collection-motion'
    },
    '6': {
        collectionName: 'motion2020',
        svgClassName: 'es_motion2020',
        tooltipImageClassname: 'collection-motion2020'
    },
    '7': {
        collectionName: 'vision',
        svgClassName: 'es_vision',
        tooltipImageClassname: 'collection-vision'
    },
    '8': {
        collectionName: 'fusion',
        svgClassName: 'es_fusion',
        tooltipImageClassname: 'collection-fusion'
    },
    '9': {
        collectionName: 'avida',
        svgClassName: 'es_avida',
        tooltipImageClassname: 'collection-avida'
    },
    '10': {
        collectionName: 'basics',
        svgClassName: 'es_basics',
        tooltipImageClassname: 'collection-basics'
    },
    '11': {
        collectionName: 'dynashield',
        svgClassName: 'es_dynashield',
        tooltipImageClassname: 'collection-dynashield'
    },
    '19': {
        collectionName: 'industry',
        svgClassName: 'es_industry',
        tooltipImageClassname: 'collection-industry'
    },
    '21': {
        collectionName: 'motionten',
        svgClassName: 'es_motionten',
        tooltipImageClassname: 'collection-motionten'
    },
    '23': {
        collectionName: 'concrete',
        svgClassName: 'es_concrete',
        tooltipImageClassname: 'collection-concrete'
    },
    '24': {
        collectionName: 'vintage',
        svgClassName: 'es_vintage',
        tooltipImageClassname: 'collection-vintage'
    },
    '26': {
        collectionName: 'trail',
        svgClassName: 'es_trail',
        tooltipImageClassname: 'collection-trail'
    },
    '29': {
        collectionName: 'iconic',
        svgClassName: 'es_iconic',
        tooltipImageClassname: 'collection-iconic'
    },
    '30': {
        collectionName: 'ambition',
        svgClassName: 'es_ambition',
        tooltipImageClassname: 'collection-ambition'
    },
    '31': {
        collectionName: 'motion247',
        svgClassName: 'es_motion247',
        tooltipImageClassname: 'collection-motion247'
    },
    '33': {
        collectionName: 'epic',
        svgClassName: 'es_epic',
        tooltipImageClassname: 'collection-epic'
    }
}